import getEnv from './getEnv'

// Amazon S3 endpoint, where the files are uploaded
const urls = {
  // local: 'https://file.orionx.com',
  local: 'https://filemanager.galaxy.orionx.com',
  dev: 'https://filemanager.andromeda.orionx.com',
  beta: 'https://filemanager.galaxy.orionx.com',
  prod: 'https://filemanager.galaxy.orionx.com',
}

const env = getEnv()

export default urls[env] || urls.dev
